import React from 'react';
import { getCollectionSortTypes, getDisplayValueFromSortType } from '@components/Explore/constants';
import { clearSortParams } from '@components/Explore/helpers';
import { Sort } from '@components/Sort';
import { useMediaQuery } from '@context/mediaQuery';
import { ParamsStore } from '@context/params';
import { SortOrder } from '@graphql/reactQuery';

export const CollectionSort = () => {
  const { tablet } = useMediaQuery();
  const sortTypes = getCollectionSortTypes({ isTablet: tablet });
  const value = getDisplayValueFromSortType({ isTablet: tablet });

  return (
    <div className="w-[110px] md:w-[204px]">
      <Sort
        value={value}
        sortTypes={sortTypes}
        parseValue={null}
        showIcon
        disabled={false}
        onValueChange={sortType => {
          clearSortParams();

          if (sortType === 'Newest') {
            return (ParamsStore.first_nft_collected_date = SortOrder.Desc);
          }

          if (sortType === 'Oldest') {
            return (ParamsStore.first_nft_collected_date = SortOrder.Asc);
          }

          return (ParamsStore.nfts_count = SortOrder.Desc);
        }}
      />
    </div>
  );
};
